export const access = (path: string, object: { [key: string]: any }) => {
  return path.split(".").reduce((o, i) => o[i], object);
};

export const isEmptyPrototype = (obj: any) => {
  if (obj && obj.constructor === Object) {
    return Object.keys(obj).length === 0;
  }
  return true;
};

export const isMobileOrTablet = () => {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    (navigator.maxTouchPoints > 1 && window.innerWidth <= 450)
  );
};

export const convertStringToHTMLFormattedString = (html: string) => {
  const htmlText = new DOMParser().parseFromString(html, "text/html");
  return htmlText.documentElement.textContent || "";
};

type SupportedTypes = "text/html" | "image/svg+xml" | "application/xml" | "text/xml";

type ParseResultMap = {
  "text/html": Document;
  "image/svg+xml": XMLDocument;
  "application/xml": XMLDocument;
  "text/xml": XMLDocument;
};

// Generic return type lookup
type ReturnTypeFor<T extends SupportedTypes> = ParseResultMap[T];

/**
 * A generic DOM parser wrapper.
 * @param input - The markup string to parse.
 * @param type - The content type of the markup.
 * @returns A parsed Document or XMLDocument based on the type.
 */
export const parseFromString = <T extends SupportedTypes>(input: string, type: T): ReturnTypeFor<T> => {
  const parser = new DOMParser();
  return parser.parseFromString(input, type) as ReturnTypeFor<T>;
};

export const validateEmail = (email: string) => {
  return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  );
};
